'use strict';

function LayersConfiguratorController($rootScope, $scope, objectMakerFactory, dataHolderFactory) {
	var self = this;

	this.updateHeatMapForContext = function(layer, context) {
		if(layer !== 'HEAT_MAP') {
			$scope.layersConfiguratorViewControl.showView = false;
			return;
		}
		$scope.layersConfiguratorViewControl.activatedConfiguration = context;
		$scope.layersConfiguratorViewControl.showView = true;
	};

	$scope.initLayersConfigurator = function() {
		$scope.layersConfiguratorViewControl = objectMakerFactory.viewObjectControlForLayersConfigurator();
	};

	$scope.didSelectLayer = function(layer) {
		(layer !== 'HEAT_MAP') && dataHolderFactory.updateLayer(layer);
		$rootScope.$emit('updateMapForLayer', layer, 'QUANTITY');
		self.updateHeatMapForContext(layer, 'QUANTITY');
	};

	$scope.didSelectConfiguration = function(configuration) {
		self.updateHeatMapForContext('HEAT_MAP', configuration);
		$rootScope.$emit('updateMapForLayer', 'HEAT_MAP', configuration);
	};

	$scope.closeHeatMap = function() {
		if(!$scope.layersConfiguratorViewControl.showView)
			return;
		$scope.layersConfiguratorViewControl.showView = false;
		$rootScope.$emit('closeHeatMap');
		$rootScope.$emit('updateMapForLayer', null);
	};

	$rootScope.$on('updateHeatMapConfigurationForSelectedLayer', function(event, layer, context) {
		self.updateHeatMapForContext(layer, context);
	});

	$rootScope.$on('applyFilters', function() {
		$scope.closeHeatMap();
	});

}

LayersConfiguratorController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory'];
export default LayersConfiguratorController


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/layersConfiguratorController.js